import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, sub }) => (
  <Reveal className="mb-14 max-w-2xl">
    <p className="eyebrow mb-4">{eyebrow}</p>
    <h2 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl">{title}</h2>
    {sub ? <p className="mt-4 text-base text-muted-foreground md:text-lg">{sub}</p> : null}
  </Reveal>
);
